class ImageGallerySwiper extends HTMLElement {
  constructor() {
    // 必须首先调用 super 方法
    super();
    this.swiper = this.querySelector(".swiper")  
  }

  connectedCallback() {
    this.initializeSwiper()
  }


  initializeSwiper(){
    const nextButton = this.querySelector('.swiper-button-next')
    const prevButton = this.querySelector('.swiper-button-prev')
    const pagination = this.querySelector('.swiper-pagination')


    const swiperParams = {
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      slidesPerView: 1,
      pagination: {
        el: pagination,
        clickable :true,
      },
    };
    
    // 初始化 Swiper
    new Swiper(this.swiper, swiperParams)
  }
    
}
customElements.define("image-gallery-swiper", ImageGallerySwiper);